import { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { Sparkles } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  useEffect(() => { document.title = "ATP Gestão 360°"; }, []);

  if (user) return <Navigate to="/app" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/app");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#07090E] grid-noise flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/atp-logo.webp" alt="ATP Confecções" className="h-16 w-auto object-contain mx-auto mb-4" />
          <p className="text-slate-400 text-sm mt-2">Acesso restrito · equipe comercial</p>
        </div>
        <form onSubmit={submit} className="bg-[#0B0F17] border border-slate-800 rounded-2xl p-6 space-y-4">
          <div>
            <Label className="text-slate-300 text-sm">E-mail</Label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
              className="bg-[#07090E] border-slate-800 text-slate-100 mt-1.5" data-testid="login-email" />
          </div>
          <div>
            <Label className="text-slate-300 text-sm">Senha</Label>
            <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required
              className="bg-[#07090E] border-slate-800 text-slate-100 mt-1.5" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-[#0CDBF2] hover:bg-[#0ABED4] text-[#07090E] font-semibold">
            {loading ? "Entrando..." : "Entrar"}
          </Button>
          <div className="flex items-center gap-2 text-xs text-slate-500 pt-2">
            <Sparkles size={12} className="text-[#0CDBF2]" /> Copiloto de IA integrado ao CRM
          </div>
        </form>
      </div>
    </div>
  );
}
